import React, { Component } from "react";
import Logo from "../images/logo.png";

interface Props {
  history: any;
}

export default class Auth extends Component<Props> {
  state = {
    email: "",
    password: "",
    emailError: "",
    passwordError: "",
  };

  handleChange = (event: any) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handleByPass = async () => {
    await window.localStorage.setItem("arusoil-auth", "Demo Authenticated");
    this.props.history.push("/");
  };

  render() {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex flex-row items-center justify-center">
            <img className="h-16 w-auto" src={Logo} alt="Arus Oil" />
          </div>
          <h2 className="mt-3 text-center text-3xl font-extrabold text-gray-900">
            Komuniti Hijau KRT
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Kawasan Rukun Tetangga Kuala Lumpur
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  E-mel
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-arusgreen-500 focus:border-arusgreen-500 sm:text-sm"
                  />
                  <span className="text-red-500 text-sm">
                    {this.state.emailError}
                  </span>
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Kata laluan
                </label>
                <div className="mt-1">
                  <input
                    value={this.state.password}
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-arusgreen-500 focus:border-arusgreen-500 sm:text-sm"
                    onChange={this.handleChange}
                  />
                  <span className="text-red-500 text-sm">
                    {this.state.passwordError}
                  </span>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-arusgreen-600 hover:bg-arusgreen-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-arusgreen-500"
                  onClick={this.handleByPass}
                >
                  Log masuk dengan akaun DBKL
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 right-0">
          <span className="text-gray-50" onClick={this.handleByPass}>
            Pass
          </span>
        </div>
      </div>
    );
  }
}
